module.exports = require('./promise')



//////////////////
// WEBPACK FOOTER
// ./~/universal-promise/index.js
// module id = 653
// module chunks = 0